import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: false, // Maak de pipe standalone voor eenvoudiger gebruik
})
export class SafeHtmlPipe implements PipeTransform {
  // Gebruik de inject-functie om de service te injecteren
  private sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml | null {
    if (value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    return null;
  }
}
